import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Camera, Users, Wallet, ScanLine } from "lucide-react";
import { Header } from "@/components/Header";

const HERO =
  "https://images.unsplash.com/photo-1778940517363-ddf1e954cfc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxmcmllbmRzJTIwZGluaW5nJTIwcmVzdGF1cmFudCUyMHRhYmxlfGVufDB8fHx8MTc4MjM5NjYxNHww&ixlib=rb-4.1.0&q=85";

const steps = [
  { icon: Camera, title: "Fotografiezi bonul", desc: "AI-ul extrage automat toate produsele, prețurile și totalul." },
  { icon: Users, title: "Toți se alătură prin link/QR", desc: "Fiecare își scrie numele și bifează ce a consumat." },
  { icon: Wallet, title: "Vezi exact cât are de plătit fiecare", desc: "Taxe, bacșiș și reduceri împărțite corect, proporțional." },
];

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6">
        <section className="pt-10 pb-8">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="relative rounded-[32px] overflow-hidden border border-border"
          >
            <img src={HERO} alt="Prieteni la restaurant" className="w-full h-[340px] sm:h-[420px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10" />
            <div className="absolute inset-0 p-6 sm:p-10 flex flex-col justify-end">
              <span className="text-xs uppercase tracking-[0.25em] font-bold text-white/70 mb-3">
                Împarte nota în 30 de secunde
              </span>
              <h1 className="font-display text-4xl sm:text-6xl font-black tracking-tight text-white leading-[0.95]">
                Unul plătește.<br />Toți decontează corect.
              </h1>
              <p className="text-white/80 text-base sm:text-lg mt-4 max-w-md">
                Fotografiezi bonul, fiecare alege ce a consumat, iar SplitBon calculează automat cine cât îți datorează.
              </p>
            </div>
          </motion.div>

          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <button
              data-testid="create-session-button"
              onClick={() => navigate("/create")}
              className="flex-1 bg-primary text-primary-foreground rounded-full py-4 px-6 text-lg font-bold active:scale-[0.98] transition-transform flex justify-center items-center gap-2"
            >
              Creează sesiune <ArrowRight size={20} />
            </button>
          </div>
        </section>

        <section className="pb-16">
          <div className="flex items-center gap-2 mb-5 text-muted-foreground">
            <ScanLine size={18} />
            <span className="text-xs uppercase tracking-[0.2em] font-bold">Cum funcționează</span>
          </div>
          <div className="grid gap-4">
            {steps.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                className="p-5 bg-card border border-border rounded-[24px] flex items-start gap-4 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
              >
                <span className="w-12 h-12 shrink-0 rounded-2xl bg-secondary flex items-center justify-center">
                  <s.icon size={22} />
                </span>
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-mono text-xs text-muted-foreground">0{i + 1}</span>
                    <h3 className="font-display text-lg font-bold">{s.title}</h3>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1">{s.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
